var ProvadorUI = {
  elements: {},
  loadingSteps: [
    "Analisando estrutura corporal...",
    "Comparando modelagem da peça...",
    "Calculando fit ideal..."
  ],

  init: function(config) {
    this.config = config;
    this.cacheElements();
    this.bindEvents();
    
    // Focus Trap setup
    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  },

  cacheElements: function() {
    this.elements = {
      overlay: document.getElementById('pv-modal-overlay'),
      openBtns: document.querySelectorAll('#pv-open-btn, .pv-open-btn, [data-action="open-provador"]'),
      closeBtns: document.querySelectorAll('#pv-close-btn, .pv-close'),
      inputAltura: document.getElementById('pv-altura'),
      inputPeso: document.getElementById('pv-peso'),
      inputIdade: document.getElementById('pv-idade'),
      btnDescobrir: document.getElementById('pv-btn-descobrir'),
      btnVoltar: document.getElementById('pv-btn-voltar'),
      step1: document.getElementById('pv-step-1'),
      stepLoading: document.getElementById('pv-step-loading'),
      step2: document.getElementById('pv-step-2'),
      footer1: document.getElementById('pv-footer-1'),
      footer2: document.getElementById('pv-footer-2'),
      title: document.getElementById('pv-header-title'),
      fitBtns: document.querySelectorAll('.pv-btn-fit'),
      bodyTypeBtns: document.querySelectorAll('.pv-btn-body-type'),
      loadingText: document.getElementById('pv-loading-text'),
      resultSizeText: document.getElementById('pv-result-size-text'),
      descTorax: document.getElementById('pv-desc-torax'),
      descComp: document.getElementById('pv-desc-comp'),
      descGeral: document.getElementById('pv-desc-geral'),
      confidenceScore: document.getElementById('pv-confidence-score'),
      reasonText: document.getElementById('pv-reason-text'),
      btnAddCart: document.getElementById('pv-btn-add-cart')
    };
  },

  bindEvents: function() {
    if (this.elements.openBtns && this.elements.openBtns.length) {
      this.elements.openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openModal();
        });
      });
    }
    if (this.elements.closeBtns && this.elements.closeBtns.length) {
      this.elements.closeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeModal();
        });
      });
    }

    // Delegação no document para garantir acionamento em desktop e mobile
    document.addEventListener('click', (e) => {
      const openTrigger = e.target.closest('#pv-open-btn, .pv-open-btn, [data-action="open-provador"]');
      if (openTrigger) {
        e.preventDefault();
        this.openModal();
        return;
      }
      const closeTrigger = e.target.closest('#pv-close-btn, .pv-close');
      if (closeTrigger) {
        e.preventDefault();
        this.closeModal();
      }
    });

    if (this.elements.overlay) {
      this.elements.overlay.addEventListener('click', (e) => {
        if (e.target === this.elements.overlay) this.closeModal();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.elements.overlay && this.elements.overlay.classList.contains('active')) {
        this.closeModal();
      }
      if (e.key === 'Tab' && this.elements.overlay && this.elements.overlay.classList.contains('active')) {
        this.trapFocus(e);
      }
    });

    this.elements.bodyTypeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.elements.bodyTypeBtns.forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
        this.checkInputs();
      });
    });

    this.elements.fitBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.elements.fitBtns.forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
      });
    });

    if (this.elements.inputAltura) {
      this.elements.inputAltura.addEventListener('input', () => this.checkInputs());
    }
    if (this.elements.inputPeso) {
      this.elements.inputPeso.addEventListener('input', () => this.checkInputs());
    }
    if (this.elements.inputIdade) {
      this.elements.inputIdade.addEventListener('input', () => this.checkInputs());
    }

    if (this.elements.btnDescobrir) {
      this.elements.btnDescobrir.addEventListener('click', () => {
        if(window.ProvadorCore) window.ProvadorCore.handleCalculate();
      });
    }

    if (this.elements.btnVoltar) {
      this.elements.btnVoltar.addEventListener('click', () => this.showStep1());
    }

    if (this.elements.btnAddCart) {
      this.elements.btnAddCart.addEventListener('click', () => this.closeModal());
    }
  },

  openModal: function() {
    if (this.elements.overlay.parentNode !== document.body) {
      document.body.appendChild(this.elements.overlay);
    }
    this.elements.overlay.classList.add('active');
    document.body.style.overflow = 'hidden'; // Lock background scroll
    
    // Focus first input
    setTimeout(() => {
      if(this.elements.inputAltura) this.elements.inputAltura.focus();
    }, 100);
  },

  closeModal: function() {
    if(this.elements.overlay) this.elements.overlay.classList.remove('active');
    document.body.style.overflow = ''; // Restore background scroll
  },

  trapFocus: function(e) {
    const modal = this.elements.overlay.querySelector('.pv-modal');
    const focusableContent = modal.querySelectorAll(this.focusableElements);
    const firstFocusableElement = focusableContent[0];
    const lastFocusableElement = focusableContent[focusableContent.length - 1];

    if (e.shiftKey) { 
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else { 
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  },

  checkInputs: function() {
    const hasHeight = this.elements.inputAltura && this.elements.inputAltura.value > 0;
    const hasWeight = this.elements.inputPeso && this.elements.inputPeso.value > 0;
    const hasAge = this.elements.inputIdade && this.elements.inputIdade.value > 0;
    const hasBodyType = document.querySelector('.pv-btn-body-type.active') !== null;
    const hasFit = document.querySelector('.pv-btn-fit.active') !== null;

    if (hasHeight && hasWeight && hasAge && hasBodyType && hasFit) {
      this.elements.btnDescobrir.removeAttribute('disabled');
    } else {
      this.elements.btnDescobrir.setAttribute('disabled', 'true');
    }
  },

  showLoading: function(callback) {
    this.elements.step1.style.display = 'none';
    this.elements.footer1.style.display = 'none';
    this.elements.step2.style.display = 'none';
    this.elements.footer2.style.display = 'none';
    this.elements.stepLoading.style.display = 'flex';
    this.elements.title.innerText = 'Processando...';

    let stepIndex = 0;
    this.elements.loadingText.innerText = this.loadingSteps[stepIndex];

    const interval = setInterval(() => {
      stepIndex++;
      if (stepIndex < this.loadingSteps.length) {
        this.elements.loadingText.innerText = this.loadingSteps[stepIndex];
      } else {
        clearInterval(interval);
        setTimeout(() => {
          this.elements.stepLoading.style.display = 'none';
          if(callback) callback();
        }, 500);
      }
    }, 600); // 600ms per step
  },

  showResult: function(resultData) {
    this.elements.step2.style.display = 'block';
    this.elements.footer2.style.display = 'block';
    this.elements.title.innerText = 'Tamanho Recomendado';

    this.elements.resultSizeText.innerText = resultData.recommendedSize;
    
    // Adjust font size if text is too long (e.g. XGG) to prevent overflow
    if (resultData.recommendedSize.length >= 3) {
      this.elements.resultSizeText.style.fontSize = '46px';
    } else {
      this.elements.resultSizeText.style.fontSize = '64px';
    }
    this.elements.descTorax.innerText = resultData.chestDesc;
    this.elements.descComp.innerText = resultData.lengthDesc;
    
    if (this.elements.descGeral) {
      this.elements.descGeral.innerText = resultData.overallFit;
    }
    
    this.elements.confidenceScore.innerText = `${resultData.confidence}% de compatibilidade`;
    
    // Generate reason text
    const chestReason = resultData.metrics.chestWidth > 0 ? `combina com a largura de ${resultData.metrics.chestWidth}cm` : `possui um bom fit para o seu corpo`;
    const finalReason = `Recomendamos ${resultData.recommendedSize} porque:\n• Seu tórax ${chestReason}\n• O comprimento atende a sua altura\n• Fit esperado: ${resultData.overallFit}`;
    this.elements.reasonText.innerText = finalReason;

    this.autoSelectVariant(resultData.recommendedSize);
  },

  showStep1: function() {
    this.elements.step2.style.display = 'none';
    this.elements.footer2.style.display = 'none';
    this.elements.stepLoading.style.display = 'none';
    this.elements.step1.style.display = 'block';
    this.elements.footer1.style.display = 'block';
    this.elements.title.innerText = 'Provador Virtual';
  },

  populateForm: function(data) {
    if(this.elements.inputAltura && data.height) this.elements.inputAltura.value = data.height;
    if(this.elements.inputPeso && data.weight) this.elements.inputPeso.value = data.weight;
    if(this.elements.inputIdade && data.age) this.elements.inputIdade.value = data.age;
    
    if(data.bodyType) {
      this.elements.bodyTypeBtns.forEach(btn => {
        if(btn.getAttribute('data-body') === data.bodyType) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    if(data.fit) {
      this.elements.fitBtns.forEach(btn => {
        if(btn.getAttribute('data-fit') === data.fit) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    this.checkInputs();
  },

  autoSelectVariant: function(recommendedSize) {
    // 1. Check Availability First
    const variants = this.config.variants || [];
    let isAvailable = false;
    let fallbackVariant = null;

    if (variants.length > 0) {
      // Find variant by size
      // We assume one of the options matches the size string exactly or contains it
      const targetVariant = variants.find(v => 
        (v.option1 && v.option1.toUpperCase() === recommendedSize.toUpperCase()) ||
        (v.option2 && v.option2.toUpperCase() === recommendedSize.toUpperCase()) ||
        (v.option3 && v.option3.toUpperCase() === recommendedSize.toUpperCase()) ||
        (v.title && v.title.toUpperCase().includes(recommendedSize.toUpperCase()))
      );

      if (targetVariant) {
        isAvailable = targetVariant.available;
      }

      if (!isAvailable) {
        const sizes = ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XGG'];
        const currentIdx = sizes.findIndex(s => s.toUpperCase() === recommendedSize.toUpperCase());
        let fallbackMsg = `<strong>Atenção:</strong> Seu tamanho ideal (${recommendedSize}) está indisponível no momento.`;
        
        if (currentIdx !== -1 && currentIdx + 1 < sizes.length) {
          const fallbackSize = sizes[currentIdx + 1];
          // Check if fallback is available
          const fallbackVariant = variants.find(v => 
            (v.option1 && v.option1.toUpperCase() === fallbackSize) ||
            (v.option2 && v.option2.toUpperCase() === fallbackSize) ||
            (v.option3 && v.option3.toUpperCase() === fallbackSize) ||
            (v.title && v.title.toUpperCase().includes(fallbackSize))
          );
          
          if (fallbackVariant && fallbackVariant.available) {
            fallbackMsg = `<strong>Atenção:</strong> Seu tamanho ideal é ${recommendedSize}, mas ele está indisponível.<br><br>Recomendamos <strong>${fallbackSize}</strong> para manter um caimento parecido.`;
            recommendedSize = fallbackSize; // Change target for auto-select
          }
        }
        
        if (recommendedSize === targetVariant?.title || recommendedSize === targetVariant?.option1) {
            this.elements.reasonText.innerHTML = fallbackMsg;
            return;
        } else {
            // We found a fallback, show msg but continue to select it
            this.elements.reasonText.innerHTML += '<br><br>' + fallbackMsg;
        }
      }
    }

    // 2. DOM Auto-Select
    let clicked = false;
    
    // Try standard hidden radio inputs common in modern themes first
    const radioInputs = document.querySelectorAll(`input[type="radio"]`);
    radioInputs.forEach(radio => {
      if (radio.value && radio.value.toUpperCase() === recommendedSize.toUpperCase()) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        clicked = true;
      }
    });

    if (!clicked) {
      // Try Shopify Labels & Swatches
      const labels = document.querySelectorAll('.block-swatch__item, .variant-swatch__item, label');
      labels.forEach(label => {
        const text = label.innerText.trim().toUpperCase();
        if (text === recommendedSize.toUpperCase()) {
          label.click();
          clicked = true;
        }
      });
    }

    // Try standard select if swatch wasn't found
    if (!clicked) {
      const selects = document.querySelectorAll('select.product-form__single-selector, select[name="id"]');
      selects.forEach(select => {
        Array.from(select.options).forEach((opt, idx) => {
          if (opt.text.toUpperCase().includes(recommendedSize.toUpperCase()) || opt.value.toUpperCase() === recommendedSize.toUpperCase()) {
            select.selectedIndex = idx;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
  }
};

window.ProvadorUI = ProvadorUI;
